'use strict';

const $LOG = Symbol('log');
const $HTTP = Symbol('http');
const CONTACT = Symbol('contactService');

class ResellersController {
  constructor($log, contactService, $http, analyticsService) {
    'ngInject';

    this[$LOG] = $log;
    this[$HTTP] = $http;
    this[CONTACT] = contactService;
    this.formSubmittedSuccess = false;
    this.reseller = {
      name: '',
      companyName: '',
      url: '',
      annualSales: '',
      email: '',
      phone: '',
      message: '',
    };

    analyticsService.page();
  }

  formValid() {
    return this.validateString(this.reseller.name) &&
      this.validateString(this.reseller.companyName) &&
      this.validateUrl(this.reseller.url) &&
      this.validateAnnualSales(this.reseller.annualSales) &&
      this.validateEmail(this.reseller.email) &&
      this.validatePhone(this.reseller.phone) &&
      this.validateString(this.reseller.message);
  }

  submitForm() {
    const message = {
      type: 'reseller',
      name: this.reseller.name,
      email: this.reseller.email,
      message: `
      Company Name: ${this.reseller.companyName}
      Url: ${this.reseller.url}
      Annual Sales: ${this.reseller.annualSales}
      Phone: ${this.reseller.phone}
      Message: ${this.reseller.message}
      `,
    };

    this[CONTACT].sendEmail(message)
      .then(res => {
        if (res.status === 'success') {
          this.reseller = {
            name: '', companyName: '', url: '', annualSales: '', email: '', phone: '', message: '',
          };
          this.formSubmittedSuccess = true;
        } else {
          this[$LOG].debug(res);
        }
      });
  }

  validateAnnualSales(phone) {
    return /^[$]?[0-9,]+$/.test(phone);
  }

  validatePhone(phone) {
    return /^[0-9.-]+$/.test(phone);
  }

  validateEmail(emailString) {
    return /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,20})+$/.test(emailString);
  }

  validateString(checkString) {
    return !(checkString === '' || checkString.replace(/^\s+|\s+$/g, '').length === 0);
  }

  validateUrl(value) {
    return /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i.test(value); // eslint-disable-line max-len
  }
}

export default ResellersController;
